import { Tooltip as ChakraTooltip } from '@chakra-ui/react';

import type { Placement } from '@zag-js/popper';

export interface TooltipProps {
  content: React.ReactNode;
  children: React.ReactElement;
  placement?: Placement;
  openDelay?: number;
  closeDelay?: number;
  closeOnClick?: boolean;
  interactive?: boolean;
  contentProps?: React.ComponentProps<typeof ChakraTooltip.Content>;
}

const Tooltip = ({
  content,
  children,
  placement = 'top',
  openDelay = 200,
  closeDelay = 300,
  closeOnClick = false,
  interactive = true,
  contentProps = {},
}: TooltipProps) => (
  <ChakraTooltip.Root
    positioning={{ placement }}
    openDelay={openDelay}
    closeDelay={closeDelay}
    closeOnClick={closeOnClick}
    interactive={interactive}
  >
    <ChakraTooltip.Trigger asChild>{children}</ChakraTooltip.Trigger>
    <ChakraTooltip.Positioner>
      <ChakraTooltip.Content
        bg="gray.700"
        color="white"
        px={3}
        py={2}
        borderRadius={6}
        fontSize="sm"
        maxW="300px"
        {...contentProps}
      >
        <ChakraTooltip.Arrow />
        {content}
      </ChakraTooltip.Content>
    </ChakraTooltip.Positioner>
  </ChakraTooltip.Root>
);

export default Tooltip;
